define(function (require, exports, module) {
    var DefaultDatasources = require('../../enums/DataSourceList');
    var DatasourceManager = require('datasource-manager/datasource-manager');

    var defaults = {
        expires: 9,
        timeout: 30,
        retries: 1,
        priority: 2,
        mimetype: 'application/json',

        PROD: {
            tfsTimecodeQuery: '&timecode='
        },

        QA: {
            tfsTimecodeQuery: '&timecode='
        },

        TEST: {
            tfsTimecodeQuery: '%26timecode='
        },

        TEST_QA: {
            tfsTimecodeQuery: '%26timecode='
        }
    };

    exports.addSources = function ($overrides) {
        DatasourceManager.update('defaults', defaults);
        DatasourceManager.add(DefaultDatasources.datasourceDefinitions);
        if ($overrides) {
            DatasourceManager.add($overrides);
        }
    };
});
